import type { YAxisType } from "./YAxisProvider";

export const DEFAULT_X_AXIS_KEY = "DEFAULT_X_AXIS_KEY";
export const DEFAULT_Y_AXIS_KEY = "DEFAULT_Y_AXIS_KEY";
export const DEFAULT_MARGINS = {
  top: 30,
  bottom: 30,
  left: 50,
  right: 50,
};

export const Y_AXIS_DEFAULT: YAxisType[] = [
  {
    axisId: DEFAULT_Y_AXIS_KEY, // The id of the axis to render. If undefined, it will be the first defined axis.
    scaleType: "linear", // categories | linear | time | log
    type: "number", // number | string
    orientation: "left", // left | right
    numTicks: 5, // The number of ticks to render.
    tickFormat: (d: number) => d.toString(), // The format function for the tick labels.
    disableLine: false, // If true, the axis line is disabled.
    disableTicks: false, //If true, the ticks are disabled.
    reverse: false,
  },
];
